import React from 'react';
import LegalPage from '../components/LegalPage';

const TermsPage = () => (
  <LegalPage title="Terms & Disclaimer" updatedAt="July 2026">
    <p>
      By using ConvoCoach, you agree to the following. If you don't agree,
      please don't use the app.
    </p>

    <h2>What this is</h2>
    <p>
      ConvoCoach is a practice tool for rehearsing everyday conversations
      (difficult chats, interviews, catch-ups, and the like) against
      AI-generated characters, with feedback from an AI coach. It is provided
      for educational and self-improvement purposes only. It is not therapy,
      not counseling, and not professional, legal, medical, career, or
      relationship advice. Every character, scenario, conversation, and piece
      of feedback is fictional and generated by an AI model. None of it
      represents a real person or a professional's opinion.
    </p>

    <h2>No warranty</h2>
    <p>
      ConvoCoach is provided "as is" and "as available," with no warranties of
      any kind, whether express or implied. To the fullest extent permitted
      by law, we disclaim all implied warranties, including any implied
      warranties of merchantability, fitness for a particular purpose, and
      non-infringement. AI responses can be inaccurate, unpredictable, or
      occasionally inappropriate, and we don't guarantee the app will be
      available, error-free, or suited to any particular purpose.
    </p>

    <h2>Your API key and account</h2>
    <p>
      You may supply your own Anthropic API key to use this app. You're
      responsible for keeping that key secure and for any usage or charges it
      incurs on your Anthropic account. Your use of the Anthropic API is also
      subject to{' '}
      <a href="https://www.anthropic.com/legal/commercial-terms" target="_blank" rel="noopener noreferrer">
        Anthropic's own terms of service
      </a>.
    </p>

    <h2>Limitation of liability</h2>
    <p>
      ConvoCoach is intended for practice and self-improvement only. To the
      fullest extent permitted by law, we are not liable for any damages,
      losses, or other outcomes (direct, indirect, incidental, or
      consequential) arising from your use of, or inability to use, the app,
      including any advice, content, or feedback it generates. You use
      ConvoCoach at your own risk.
    </p>

    <h2>Acceptable use</h2>
    <p>
      Don't use ConvoCoach to generate content that is illegal, or to attempt
      to abuse, extract training data from, or otherwise misuse the underlying
      AI model outside of normal conversation practice.
    </p>

    <h2>Changes</h2>
    <p>
      These terms may change from time to time. Continued use of the app
      after a change means you accept the updated terms.
    </p>
  </LegalPage>
);

export default TermsPage;
